import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from '../../services/api';
import { Container, Table } from './styles';

import Button from '../../components/Button';
import Loading from '../../components/Loading';

export default class Requests extends Component {
  state = {
    alert: {},
    events: [],
    loading: true,
    showAlert: false,
  };

  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  componentDidMount() {
    this.loadRequests();
  }

  loadRequests = async () => {
    try {
      const { data } = await api.get('event_requests', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ events: data.events });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ events: [] });
    }
  };

  decideRequest = async (id, decision) => {
    const { events } = this.state;
    const formData = new FormData();
    formData.append('decision', decision);
    try {
      await api.put(`event_requests/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({
        events: events.map(event => ({
          ...event,
          requests: event.requests.filter(request => request.id !== id),
        })),
      });
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível alterar a solicitação. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      events,
      loading,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">Solicitações</h1>

            {events.length > 0 ? (
              <Fragment>
                {events.map(event => (
                  <div key={event.id} className="box">
                    <div className="row">
                      <div className="col-12">
                        <h4>{event.name}</h4>
                        {event.requests.length > 0 ? (
                          <div className="table-wrapper">
                            <Table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Foto</th>
                                  <th scope="col">Nome</th>
                                  <th scope="col">Gênero</th>
                                  <th scope="col">Cidade</th>
                                  <th scope="col">Instagram</th>
                                  <th scope="col">Nº de seguidores</th>
                                  <th scope="col">Engajamento</th>
                                  <th scope="col">Nota média</th>
                                  <th scope="col">Ação</th>
                                </tr>
                              </thead>
                              <tbody>
                                {event.requests.map(request => (
                                  <tr key={request.id}>
                                    <td>
                                      <div
                                        className="profile-image"
                                        style={
                                          request.promoter.avatar.url && {
                                            backgroundImage: `url(${request.promoter.avatar.url})`,
                                          }
                                        }
                                      />
                                    </td>
                                    <td>{request.promoter.name}</td>
                                    <td>{this.genreTranslation[request.promoter.genre]}</td>
                                    <td>{request.promoter.city}</td>
                                    <td>
                                      <a
                                        href={`http://instagram.com/${
                                          request.promoter.instagram_username
                                        }`}
                                        target="blank"
                                      >
                                        @{request.promoter.instagram_username}
                                      </a>
                                    </td>
                                    <td>
                                      {request.promoter.followers ? request.promoter.followers : '-'}
                                    </td>
                                    <td>
                                      {request.promoter.engagement
                                        ? request.promoter.engagement
                                        : '-'}
                                    </td>
                                    <td>{request.promoter.rating ? request.promoter.rating : '-'}</td>
                                    <td>
                                      <Button
                                        onClick={() => this.decideRequest(request.id, 'reject')}
                                        className="btn-outline-danger btn-small"
                                      >
                                        <FontAwesomeIcon icon={faTimes} />
                                      </Button>
                                      <Button
                                        onClick={() => this.decideRequest(request.id, 'accept')}
                                        className="btn-outline-success btn-small"
                                      >
                                        <FontAwesomeIcon icon={faCheck} />
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ) : (
                          <h5 className="text-center" style={{ marginTop: 30 }}>
                            Evento não possui solicitações pendentes.
                          </h5>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </Fragment>
            ) : (
              <div className="box">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-center">Você não possui solicitações de divulgação.</h5>
                  </div>
                </div>
              </div>
            )}

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Requests/index.js